<template>
  <v-tooltip
    :bottom="position === 'bottom'"
    :right="position === 'right'"
    :left="position === 'left'"
    :top="position === 'top'"
    :max-width="maxWidth">
    <template v-slot:activator="{ on, attrs }">
      <i v-bind="attrs" v-on="on">
        <slot name="tip-icon"></slot>
      </i>
    </template>
    <slot name="tip-content"></slot>
  </v-tooltip>
</template>

<script>
export default {
  name: 'arb-basic-tooltips',
  props: {
    position: {
      type: String,
      default: 'bottom'
    },
    maxWidth: {
      type: String,
      default: '800px'
    }
  }
}
</script>
